// extracted by mini-css-extract-plugin
export var icon = "_50-1";
export var subtext = "_50-0";